<!-- Note that this is based on, but modified from, the corresponding template in polymorphic-page -->

<template>

  <GoDialog class="GatedContentDialog" ref="dialog" background-color="dark-blue" @closed="dialogClosed">

    <div class="withBlurredBackdrop">

      <!--
        The structure of this piece must match that of the main content below, so that the blurred
        image aligns with the foreground image at all breakpoints.
       -->
      <div class="dialogContents blurredBackdrop">
        <div class="image">
          <SanityImage v-if="content.image" :asset="content.image.asset" loading="eager" />
        </div>
      </div>

      <div class="dialogContents nonBlurredOverlay">
        <div class="header">
          <span v-if="content.label" class="label">{{ content.label }}</span>
          <h3 class="heading">{{ content.heading }}</h3>
        </div>
        <div>
          <div class="image">
            <SanityImage v-if="content.image" :asset="content.image.asset" width="388" />
          </div>
          <div v-if="content.popoverBody" class="body">
            <PortableText :value="content.popoverBody" />
          </div>
        </div>
        <div>
          <GatedContentForm
            :buttonText="content.ctaText"
            :locale="content.locale"
            :requestedContent="content.requestedContent"
            class="contactForm"
          />
        </div>
      </div>

    </div>

  </GoDialog>

</template>

<script>
import { pushAnalyticsEvent } from '~/lib/analyticsEvents.js'

import GatedContentForm from './Form.vue'
import GoDialog from '~/vue-components/shared/GoDialog.vue'

export default {
  components: {
    GatedContentForm,
    GoDialog,
},
  props: {
    content: Object,
  },
  methods: {
    showModal() {
      if (typeof window !== 'undefined') {
        this.$refs.dialog.showModal()
        sessionStorage['gatedContentModalStatus'] = 'seen'
      }
    },
    dialogClosed() {
      pushAnalyticsEvent({
        scope: 'gatedContentDownloadModule',
        action: 'popupDismissed',
        content: this.content,
      })
    },
  },
}
</script>

<style scoped>

.withBlurredBackdrop {
  display: grid;
  overflow: hidden;
}

.blurredBackdrop, .nonBlurredOverlay {
  position: relative;
  grid-column: 1;
  grid-row: 1;
}

.blurredBackdrop {
  filter: blur(50px);
  align-items: center;
}

.dialogContents {
  padding: var(--spacing-10);
}

.dialogContents:has(.logoStrip:last-child) {
  padding-bottom: var(--spacing-10);
}

.header {
  margin-bottom: var(--spacing-9);
}

.image {
  display: none;
}

.label {
  font-weight: 600;
  font-size: var(--font-size-2);
  text-transform: uppercase;
  color: var(--brand-color);
}

.heading {
  margin-top: 0.25rem;
  font-weight: 600;
  font-size: var(--font-size-8);
  line-height: 1.1;
  color: var(--heading-color);
}

.body {
  margin-top: var(--spacing-7);
  font-weight: 400;
  font-size: var(--font-size-2);
  line-height: 1.75;
  color: var(--heading-color);
}

.body:deep(p) {
  margin-top: var(--spacing-0);
}

.contactForm {
  margin-top: var(--spacing-8);
}

@media (--screen-lg) {

  .dialogContents {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: var(--spacing-15);
    padding: var(--spacing-12);
  }

  .header, .logoStrip {
    grid-column: 1 / span 2;
  }

  .image {
    display: block;
  }

  .blurredBackdrop .image {
    transform: scale(2);
    transform-origin: 94% 50%;
    opacity: 0.4;
  }

  .contactForm {
    margin-top: 0;
  }
}
</style>
